export default __webpack_public_path__ + "static/main-backend-as-a-service-517423e69d2f5e3f0e8c9474fd82fee6.png";